
import Avatar from "~/components/ui/Avatar.vue";
import ProfileTags from "@/components/v2/profile-tags.vue";

export default {
  components: {
    Avatar,
    ProfileTags,
  },

  props: {
    profile: {
      type: Object,
      required: true,
    },
  },

  computed: {
    name() {
      return this.profile.mainPhoto;
    },

    age() {
      return this.profile.age;
    },

    city() {
      return this.profile.city;
    },

    slug() {
      return this.profile.slug;
    },
  },
};
